import { Component, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ExportCertificateReportService } from "src/app/services/export-certificate-report.service";

export type IExportRes = {
  id: string;
  title: string;
  status: "Completed" | "InProcess";
};

export type IFileExportedSuccess = {
  id: number;
  exportedBy: string;
  title: string;
  link: string;
  status: string;
};

export type IUpdateRes = {
  data: {
    status: "Completed" | "InProcess";
  };
};

@Component({
  selector: "app-export",
  templateUrl: "./export-component.component.html",
  styleUrls: ["./export-component.component.scss"]
})
export class ExportComponentComponent implements OnDestroy {
  @Input() isLoadingExport: boolean;

  private subscriptions: Subscription = new Subscription();

  isLoading: boolean = true;
  exportInputData: any;
  fileName: string = "asd.xlx";
  isOpen: boolean = true;
  exportResponse: IExportRes = {} as IExportRes;
  intervalId: any;
  timeoutId: any;
  maxDuration = 15 * 60 * 1000; // 15 minute
  fileCurrentStatus: "Completed" | "InProcess" | "" = "";
  finalFileUrl: string = "";

  constructor(
    private exportCertificateReportService: ExportCertificateReportService
  ) {
    localStorage.setItem("is_exporting_model", "1");
    this.subscriptions.add(
      exportCertificateReportService.exportData$.subscribe((data: any) => {
        console.log('this.exportInputData', data);

        this.exportInputData = data;
        if (data) {
          // Start interval and timeout
          this.getUpdateOnExport(this.exportResponse?.id);
          this.intervalId = setInterval(() => {
            this.getUpdateOnExport(this.exportResponse?.id);
          }, 20000);

          this.timeoutId = setTimeout(() => {
            this.resetAll();
          }, this.maxDuration);
        } else {
          this.resetAll();
        }
        if (this.exportInputData?.company) {
          this.exportCertificatesReporting();
        }
      })
    );

    this.subscriptions.add(
      this.exportCertificateReportService.checkExportStatusData$.subscribe((data) => {
        if (data.status) {
          this.exportResponse = data;
          this.getUpdateOnExport(data.id);
        }
      })
    );
  }

  onArrowClick(isOpen: boolean): void {
    this.isOpen = isOpen;
  }

  exportCertificatesReporting() {
    setTimeout(() => {
      this.exportCertificateReportService.addExportRequest(this.exportInputData).subscribe({
        next: (res: any) => {
          this.exportResponse = res;
          this.fileCurrentStatus = res.status;
          // Start interval and timeout
          this.getUpdateOnExport(this.exportResponse.id);
          this.intervalId = setInterval(() => {
            this.getUpdateOnExport(this.exportResponse.id);
          }, 20000);

          this.timeoutId = setTimeout(() => {
            this.resetAll();
            console.log("Timeout: No response within 15 minutes.");
          }, this.maxDuration);
        },
        error: (err: any) => {
          alert(
            err?.ResponseException || "Error in exporting"
          );
        }
      });
    });
  }

  getUpdateOnExport(id: string) {
    if (!id) {
      return;
    }
    this.exportCertificateReportService
      .getExportRequestStatus(id)
      .subscribe((res: any) => {
        console.log("ressssssssssssssssss", res);

        this.fileCurrentStatus = res.result?.status;
        if (res && res['result'].status == "Completed") {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
          if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
          }
          this.getFileDetails(this.exportResponse.id);
        }
      }, (err) => {
        this.isLoading = false;
        this.resetAll();
        alert(
          err?.ResponseException || "Error in exporting"
        )
      });
  }

  getFileDetails(id: string) {
    this.exportCertificateReportService
      .getExportRequestDetails(id)
      .subscribe({
        next: (res: any) => {
          this.finalFileUrl = res.link;
          this.isLoading = false;
          this.isOpen = true;
        },
        error: (err: any) => {
          this.resetAll();
          alert(
            err?.ResponseException || "Error in exporting"
          );
        }
      });
  }

  deleteCurrentDownload() {
    if (!this.exportResponse.id) {
      return;
    }
    this.exportCertificateReportService
      .deleteCurrentDownload(this.exportResponse.id)
      .subscribe({
        next: (res: any) => {
          // this.resetAll();
          window.location.reload();
        },
        error: (err: any) => {
          // this.resetAll();
          alert(
            err?.ResponseException || "Something Went Wrong !"
          );
          window.location.reload();
        }
      });
  }

  downloadFile() {
    this.removeLocalStorage();
    window.open(this.finalFileUrl, "_blank");
    this.resetAll();
    this.deleteCurrentDownload();
  }

  resetAll(): void {
    this.isLoading = false;
    this.fileCurrentStatus = "";
    this.finalFileUrl = "";
    this.finalFileUrl = "";
    this.exportCertificateReportService.setLoading(false);
    this.exportCertificateReportService.reset();
    this.removeLocalStorage();
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  removeLocalStorage() {
    localStorage.removeItem("is_exporting_model");
    localStorage.removeItem("export_certificate_report_data");
    localStorage.removeItem("export_certificate_report_response");
    localStorage.removeItem("certificate_report_current_status");
    localStorage.removeItem("wasPageRefreshed");
  }

  ngOnDestroy(): void {
    localStorage.removeItem("is_exporting_model");
    this.subscriptions.unsubscribe();
    this.resetAll();
  }
}
